import { isSidebarRouteActive } from "./sidebarRouteActive"
import React, { Component, Suspense, lazy } from "react"
import PropTypes from "prop-types"
import { withNamespaces, Trans } from "react-i18next"
import { Link, withRouter } from "react-router-dom"
import { Collapse, Badge } from "reactstrap"

import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as actions from "../../store/actions/actions"
import { setZooTier, setUserRole, setZooTimezone, setZooOptions, changeZooName, setAkongoStaff } from "../../store/actions/zoo.actions"

import SidebarRun from "./Sidebar.run"
import SidebarUserBlock from "./SidebarUserBlock"

import MenuPedago from "../../Menu/MenuPedago.js"
import MenuAdmin from "../../Menu/MenuAdmin.js"
import MenuSuperAdmin from "../../Menu/MenuSuperAdmin"
import MenuUser from "../../Menu/MenuUser.js"
import { generateMenu } from "../../Menu/MenuConfig.js"
import { ZimsCollectionConnector } from "../../dataconnector/zimsCollectionConnector"
import { getZooId, initAuth } from "../../tools/conf"
import { canOpenV2 } from "../../navigation-v2/app/stagingRuntime"
import { UserDatabaseConnector } from "../../dataconnector/usersDatabaseConnector"
import { getTicketConnector } from "../../dataconnector/ticketDatabaseConnector"

// Le selecteur V1/V2 tire tout `navigation-v2` + `design-system/v2` (~280 Ko gz)
// dans le chunk principal s'il est importe statiquement : charge a la demande,
// pour le staff AKONGO et les parcs qui laissent le choix d'interface.
const LegacyInterfaceVersionSwitch = lazy(() =>
  import("../../navigation-v2/app/LegacyInterfaceVersionSwitch")
)

const uConnect = new UserDatabaseConnector()

/** Component to display collapsible headings on sidebar */
const SidebarItemHeader = ({ item, isCollapsed, onToggle }) => (
  <li
    className='nav-heading'
    onClick={onToggle}
    style={{
      cursor: 'pointer',
      pointerEvents: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      userSelect: 'none'
    }}
  >
    <span>
      <Trans i18nKey={item.translate}>{item.heading}</Trans>
    </span>
    <em
      className={isCollapsed ? 'fa fa-chevron-down' : 'fa fa-chevron-up'}
      style={{
        fontSize: '10px',
        marginRight: '10px',
        transition: 'transform 0.2s ease',
        opacity: 0.6
      }}
    />
  </li>
)

/** Normal items for the sidebar */
const SidebarItem = ({ item, isActive }) => {
  const isCollapsed = typeof document !== 'undefined' &&
    (document.body.classList.contains('aside-collapsed') ||
     document.body.classList.contains('aside-collapsed-text'));

  const itemPath = item.path.startsWith('/') ? item.path : `/${item.path}`;

  return (
    <li className={isActive ? "active" : ""}>
      <Link
        to={itemPath}
        title={item.name} 
        style={!isCollapsed ? { display: "flex", alignItems: "center", flexWrap: "wrap" } : {}}
      >
        {item.label && (
          <Badge tag='div' className='float-right' color={item.label.color}>
            {item.label.value}
          </Badge>
        )}
        {item.icon && <em className={item.icon} style={!isCollapsed ? { flexShrink: 0 } : {}}></em>}
        <span style={!isCollapsed ? { 
          whiteSpace: "normal",
          wordBreak: "break-word",
          lineHeight: "1.3",
          flex: 1,
          paddingRight: "8px"
        } : {}}>
          <Trans i18nKey={item.translate}>{item.name}</Trans>
        </span>
      </Link>
    </li>
  );
}

/** Build a sub menu with items inside and attach collapse behavior */
const SidebarSubItem = ({ item, isActive, handler, children, isOpen }) => {
  const isCollapsed = typeof document !== 'undefined' && 
    (document.body.classList.contains('aside-collapsed') || 
     document.body.classList.contains('aside-collapsed-text'));
  
  return (
    <li className={isActive ? "active" : ""}>
      <div 
        className='nav-item' 
        onClick={handler} 
        style={!isCollapsed ? { display: "flex", alignItems: "center", flexWrap: "wrap", cursor: "pointer" } : { cursor: "pointer" }}
      >
        {item.label && (
          <Badge tag='div' className='float-right' color={item.label.color}>
            {item.label.value}
          </Badge>
        )}
        {item.icon && <em className={item.icon} style={!isCollapsed ? { flexShrink: 0 } : {}}></em>}
        <span style={!isCollapsed ? { 
          whiteSpace: "normal",
          wordBreak: "break-word",
          lineHeight: "1.3",
          flex: 1,
          paddingRight: "8px"
        } : {}}>
          <Trans i18nKey={item.translate}>{item.name}</Trans>
        </span>
      </div>
      <Collapse isOpen={isOpen}>
        <ul id={item.path} className='sidebar-nav sidebar-subnav'>
          {children}
        </ul>
      </Collapse>
    </li>
  );
}

/** Component used to display a header on menu when using collapsed/hover mode */
const SidebarSubHeader = ({ item }) => <li className='sidebar-subnav-header'>{item.name}</li>

export class Sidebar extends Component {
  state = {
    Menu: MenuUser,
    collapse: {},
    sectionCollapse: {}, // État pour les sections (headings) rétractables
  }
  componentDidUpdate(prevProps) {
    // Vérifier si le tier, rôle ou options Redux ont changé
    const optionsChanged = JSON.stringify(prevProps.zooOptions) !== JSON.stringify(this.props.zooOptions)
    if (prevProps.zooTier !== this.props.zooTier || prevProps.userRole !== this.props.userRole || optionsChanged) {
      const zooTier = this.props.zooTier || 'essential'
      const userRole = this.props.userRole || 'user'
      const zooOptions = this.props.zooOptions || {}

      console.log('Sidebar: Regenerating menu with tier:', zooTier, 'role:', userRole, 'options:', zooOptions)
      const generatedMenu = generateMenu(zooTier, userRole, zooOptions)

      this.setState({
        Menu: generatedMenu,
        userRole: userRole,
        zooTier: zooTier,
        zooOptions: zooOptions,
      }, () => {
        this.buildCollapseList()
      })
    }
  }
  
  async componentDidMount() {
    const request = this._scopeRequest = (this._scopeRequest || 0) + 1;
    const selectionRevision = this.props.zoo?.productScopeSelectionRevision || 0;
    let authUid = null;
    const isCurrent = () => this._scopeRequest === request
      && (this.props.zoo?.productScopeSelectionRevision || 0) === selectionRevision
      && (!authUid || initAuth().currentUser?.uid === authUid);
    try {
      // Utiliser _waitForAuthState pour attendre que Firebase ait restauré la session
      // Ceci est nécessaire pour l'ouverture d'URL en nouvel onglet
      let data = await uConnect._waitForAuthState()
      if (!isCurrent()) return;
      if (!data.success) {
        this.props.history.push({
          pathname: "/login",
        })
        return
      }
      authUid = data.data?.uid;
      let res = await uConnect._getUserRight()
      if (!isCurrent()) return;

      // Récupérer le tier et le timezone depuis la base de données
      console.log('Sidebar: Fetching zoo data from DB')
      let zooData = await uConnect._getZooData()
      console.log('Raw zoo data from _getZooData:', zooData)
      console.log('Sidebar componentDidMount: followUpLevel from zooData:', zooData?.data?.followUpLevel)
      if (!isCurrent()) return;
      if (zooData?.data?.zooId && zooData.data.zooId !== this.props.zoo?.zooId
        && (this.props.zoo?.productScopeReady || this.props.zoo?.productScopeSelectionPending)) return;
      let zooTier = zooData?.data?.followUpLevel || 'essential'
      let zooTimezone = zooData?.data?.timezone || null
      if (!zooData?.success || !zooData.data) throw new Error("Zoo context unavailable");
      let zooOptions = {
        zooId: zooData.data.zooId,
        tourneeEnabled: zooData?.data?.tourneeEnabled === true,
        mandatoryObjectives: zooData?.data?.mandatoryObjectives !== false,
        zimsSyncConfig: zooData?.data?.zimsSyncConfig || null,
        featureFlags: zooData?.data?.featureFlags || {},
        // Version d'interface décidée par AKONGO : c'est elle qui décide si le
        // sélecteur V1↔V2 existe pour les membres de ce parc.
        interfacePolicy: zooData?.data?.interfacePolicy ?? null,
        productConfiguration: zooData?.data?.productConfiguration ?? null,
        rafikiAccess: zooData?.data?.rafikiAccess ?? null,
        // Suivi BEA : stockage du parc (nouveau suivi une fois migré), cf. welfare-follow-up/gateway.
        welfareFollowUp: zooData?.data?.welfareFollowUp ?? null,
        // Historical tier, read by capabilities that did not exist before the catalogue (planning generation).
        followUpLevel: zooData?.data?.followUpLevel ?? null,
        zooTiers: zooData?.data?.zooTiers ?? null,
        weatherConfig: zooData?.data?.weatherConfig || null,
        gamificationConfig: zooData?.data?.gamificationConfig || null,
      }

      // Mapper les valeurs legacy pour être sûr
      if (zooTier === 'basic') {
        console.log('Sidebar: Mapping legacy "basic" tier to "essential"')
        zooTier = 'essential'
      }

      let userRole = res.data.userRight || 'user'
      const userData = localStorage.getItem('userData')
      const parsedUserData = userData ? JSON.parse(userData) : {}
      const isAkongoMember = parsedUserData.akongoStaff === true || parsedUserData.akongoRank === 'board'
      // Resynchronise le flag d'accès V2 (posé au login) au boot / refresh :
      // le staff garde le sélecteur V1↔V2 quel que soit le régime du parc.
      const isAkongoStaff = parsedUserData.akongoStaff === true
      if (this.props.zoo?.akongoStaff !== isAkongoStaff) {
        this.props.setAkongoStaff(isAkongoStaff)
      }

      console.log('User role:', userRole, 'Zoo tier (followUpLevel):', zooTier)

      // Générer le menu dynamiquement selon le tier et le rôle
      console.log('Sidebar: Generating menu for tier:', zooTier, 'and role:', userRole)
      const generatedMenu = generateMenu(zooTier, userRole, zooOptions)
      console.log('Sidebar: Generated menu has', generatedMenu.length, 'items')
      console.log('Sidebar: Menu items:', generatedMenu.map(item => item.name || item.heading))

      // Mettre à jour le store Redux avec le tier et le rôle
      console.log('Sidebar componentDidMount: Current Redux tier:', this.props.zooTier)
      console.log('Sidebar componentDidMount: Tier to use:', zooTier)

      // Ne mettre à jour Redux que si nécessaire pour éviter les cycles de mise à jour
      if (this.props.zooTier !== zooTier) {
        console.log('Sidebar componentDidMount: Updating Redux with tier:', zooTier)
        this.props.setZooTier(zooTier)
      }
      if (this.props.userRole !== userRole) {
        console.log('Sidebar componentDidMount: Updating Redux with role:', userRole)
        this.props.setUserRole(userRole)
      }
      if (this.props.timezone !== zooTimezone) {
        console.log('Sidebar componentDidMount: Updating Redux with timezone:', zooTimezone)
        this.props.setZooTimezone(zooTimezone)
      }
      // Le nom du parc affiché vient de `users/{uid}.userZoo.label`, une copie dénormalisée
      // figée à la création du compte : un renommage du parc ne s'y propage jamais.
      // On resynchronise depuis le document parc, seule source de vérité.
      const freshZooName = zooData?.data?.zooName
      if (freshZooName && this.props.zoo?.zooName !== freshZooName) {
        console.log('Sidebar componentDidMount: Updating Redux with zoo name:', freshZooName)
        this.props.setZooName(freshZooName)
      }
      this.props.setZooOptions(zooOptions)

      this.setState({
        Menu: generatedMenu,
        userRole: userRole,
        zooTier: zooTier,
        zooOptions: zooOptions,
      }, () => {
        console.log('Sidebar componentDidMount: State updated with menu of', this.state.Menu.length, 'items')
      })

      // Fallback sur les anciens menus si nécessaire
      if ((!generatedMenu || generatedMenu.length === 0) && zooOptions.productConfiguration == null) {
        console.warn('Using fallback menu for role:', userRole)
        if (userRole === "superAdmin") {
          this.setState({
            Menu: MenuSuperAdmin,
          })
        } else if (userRole === "admin") {
          this.setState({
            Menu: MenuAdmin,
          })
        } else if (userRole === "pedagoadmin") {
          this.setState({
            Menu: MenuPedago,
          })
        } else {
          this.setState({
            Menu: MenuUser,
          })
        }
      }

      // Badge temps réel pour les tickets support (Akongo staff uniquement)
      if (isAkongoMember) {
        this.setupAdminTicketBadge()
      }

      // Badge temps réel des réponses non lues sur MES tickets (tout le monde)
      this.setupUnreadRepliesBadge()

      // Badge temps réel des mouvements ZIMS en attente, dès que l'entrée
      // « Collection ZIMS » est au menu (synchro ou import d'un fichier ZIMS)
      const hasMenuPath = (items, path) => (items || []).some((item) => item.path === path || hasMenuPath(item.submenu, path))
      if (hasMenuPath(generatedMenu, 'ZimsCollection')) {
        this.setupZimsMovementsBadge()
      }
    } catch (error) {
      if (!isCurrent()) return;
      this.props.setZooOptions({ scopeLoadFailed: true, productConfiguration: { version: "unavailable" } });

      console.log(error)

      this.props.history.push({
        pathname: "/login",
      })
    }

    // pass navigator to access router api
    if (!isCurrent()) return;
    SidebarRun(this.navigator, this.closeSidebar)
    // prepare the flags to handle menu collapsed states
    this.buildCollapseList()

    // Listen for routes changes in order to hide the sidebar on mobile
    this.historyUnsubscribe = this.props.history.listen(this.closeSidebar)
  }

  closeSidebar = () => {
    this.props.actions.changeSetting("asideToggled", false)
  }

  componentWillUnmount() {
    this._scopeRequest = (this._scopeRequest || 0) + 1;
    this.historyUnsubscribe?.();
    if (this.ticketBadgeUnsubscribe) {
      this.ticketBadgeUnsubscribe()
    }
    if (this.unreadRepliesBadgeUnsubscribe) {
      this.unreadRepliesBadgeUnsubscribe()
    }
    if (this.zimsMovementsBadgeUnsubscribe) {
      this.zimsMovementsBadgeUnsubscribe()
    }
  }

  // Badge « réponses non lues » sur l'entrée « Tickets support » du demandeur.
  // Distinct du badge Akongo staff, qui compte les tickets ouverts de tous les parcs.
  setupUnreadRepliesBadge() {
    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}')
      const userId = userData.userId
      if (!userId) return

      const connector = getTicketConnector()
      this.unreadRepliesBadgeUnsubscribe = connector.subscribeToUnreadRepliesCount(
        userId,
        (count) => {
          this.setState((prevState) => {
            const updatedMenu = prevState.Menu.map((item) => {
              if (item.path === 'SupportTicketsView') {
                return {
                  ...item,
                  label: count > 0 ? { value: count > 99 ? '99+' : count, color: 'danger' } : undefined,
                }
              }
              return item
            })
            return { Menu: updatedMenu }
          })
        }
      )
    } catch (error) {
      console.error('[Sidebar] setupUnreadRepliesBadge error:', error)
    }
  }

  setupAdminTicketBadge() {
    try {
      const connector = getTicketConnector()
      this.ticketBadgeUnsubscribe = connector.subscribeToOpenTicketsCount((count) => {
        this.setState((prevState) => {
          const updatedMenu = prevState.Menu.map((item) => {
            if (item.path === 'AdminTicketsView') {
              return {
                ...item,
                label: count > 0 ? { value: count, color: 'danger' } : undefined,
              }
            }
            return item
          })
          return { Menu: updatedMenu }
        })
      })
    } catch (error) {
      console.error('[Sidebar] setupAdminTicketBadge error:', error)
    }
  }

  // Badge du nombre de propositions de mouvements ZIMS en attente sur
  // l'entrée « Collection ZIMS » (même mécanique que le badge tickets).
  async setupZimsMovementsBadge() {
    const request = this._scopeRequest;
    try {
      const zooId = await getZooId()
      if (request !== this._scopeRequest) return;
      if (!zooId || zooId === "demo") return
      const connector = new ZimsCollectionConnector()
      this.zimsMovementsBadgeUnsubscribe = connector._subscribeToPendingMovementsCount(zooId, (count) => {
        this.setState((prevState) => {
          const updatedMenu = prevState.Menu.map((item) => {
            if (item.path === 'ZimsCollection') {
              return {
                ...item,
                label: count > 0 ? { value: count > 99 ? '99+' : count, color: 'danger' } : undefined,
              }
            }
            return item
          })
          return { Menu: updatedMenu }
        })
      })
    } catch (error) {
      console.error('[Sidebar] setupZimsMovementsBadge error:', error)
    }
  }

  /** prepare initial state of collapse menus. Doesnt allow same route names */
  buildCollapseList = () => {
    let collapse = {}
    // Accordéon : au plus UN sous-menu ouvert au chargement (le premier dont un enfant
    // correspond à la route active).
    let openedOne = false
    this.state.Menu.filter(({ heading, submenu }) => !heading && submenu).forEach(({ name, submenu }) => {
      const active = !openedOne && this.routeActive(submenu.map(({ path }) => path))
      collapse[name] = active
      if (active) openedOne = true
    })
    this.setState({ collapse, sectionCollapse: this.buildSectionCollapseList() })
  }

  /**
   * Accordéon des sections (headings) : au chargement, seule la section contenant
   * la route active est ouverte. Si aucune route ne matche, la première section
   * reste ouverte pour ne pas afficher un menu entièrement replié.
   */
  buildSectionCollapseList = () => {
    const sections = []
    let currentSection = null
    let activeSection = null

    this.state.Menu.forEach((item) => {
      if (item.heading) {
        currentSection = item.heading
        sections.push(item.heading)
      } else if (currentSection && !activeSection) {
        const paths = item.submenu ? item.submenu.map(({ path }) => path) : item.path
        if (paths && this.routeActive(paths)) activeSection = currentSection
      }
    })

    const openSection = activeSection || sections[0] || null
    const sectionCollapse = {}
    sections.forEach((heading) => {
      sectionCollapse[heading] = heading !== openSection
    })
    return sectionCollapse
  }

  navigator = (route) => {
    this.props.history.push(route.replace("#", "")) // remove '#' in case of use HashRouter
  }

  routeActive(paths) {
    return isSidebarRouteActive(this.props.location.pathname, paths)
  }

  toggleItemCollapse(stateName) {
    // Accordéon : un seul sous-menu déplié à la fois. On reconstruit l'objet `collapse`
    // (en préservant toutes les clés) : tout est fermé, puis on (ré)ouvre uniquement
    // celui cliqué s'il était fermé. setState fonctionnel pour éviter la perte d'état.
    this.setState((prevState) => {
      const wasOpen = prevState.collapse[stateName] === true
      const collapse = {}
      Object.keys(prevState.collapse).forEach((c) => {
        collapse[c] = false
      })
      collapse[stateName] = !wasOpen
      return { collapse }
    })
  }

  getSubRoutes = (item) => item.submenu.map(({ path }) => path)

  /**
   * Toggle section collapse state — accordéon : une seule section ouverte à la
   * fois. Ouvrir une section ferme les autres ; re-cliquer sur la section déjà
   * ouverte la ferme aussi (on peut donc tout replier).
   */
  toggleSectionCollapse = (sectionName) => {
    this.setState((prevState) => {
      const isCurrentlyCollapsed = prevState.sectionCollapse[sectionName] === true
      const sectionCollapse = {}
      Object.keys(prevState.sectionCollapse).forEach((s) => {
        // Section fermée → on l'ouvre et on ferme les autres (accordéon).
        // Section ouverte → on ferme tout (aucune section ouverte).
        sectionCollapse[s] = isCurrentlyCollapsed ? s !== sectionName : true
      })
      return { sectionCollapse }
    })
  }

  /** map menu config to string to determine which element to render */
  itemType = (item) => {
    if (item.heading) return "heading"
    if (!item.submenu) return "menu"
    if (item.submenu) return "submenu"
  }

  /** Render menu items, handling section collapse */
  renderMenuItems() {
    const items = []
    let currentSection = null

    this.state.Menu.forEach((item, i) => {
      if (this.itemType(item) === "heading") {
        currentSection = item.heading
        items.push(
          <SidebarItemHeader
            item={item}
            key={`heading-${i}`}
            isCollapsed={this.state.sectionCollapse[item.heading]}
            onToggle={() => this.toggleSectionCollapse(item.heading)}
          />
        )
      } else {
        // Vérifier si la section parente est collapsed
        const isSectionCollapsed = currentSection && this.state.sectionCollapse[currentSection]

        if (!isSectionCollapsed) {
          if (this.itemType(item) === "menu") {
            items.push(
              <SidebarItem
                isActive={this.routeActive(item.path)}
                item={item}
                key={`item-${i}`}
              />
            )
          }
          if (this.itemType(item) === "submenu") {
            items.push(
              <SidebarSubItem
                item={item}
                isOpen={this.state.collapse[item.name]}
                handler={this.toggleItemCollapse.bind(this, item.name)}
                isActive={this.routeActive(this.getSubRoutes(item))}
                key={`submenu-${i}`}
              >
                <SidebarSubHeader item={item} key={`subheader-${i}`} />
                {item.submenu.map((subitem, j) => (
                  <SidebarItem
                    key={`subitem-${i}-${j}`}
                    item={subitem}
                    isActive={this.routeActive(subitem.path)}
                  />
                ))}
              </SidebarSubItem>
            )
          }
        }
      }
    })

    return items
  }

  render() {
    return (
      <aside className='aside-container'>
        {/* START Sidebar (left) */}
        <div className='aside-inner'>
          <nav data-sidebar-anyclick-close='' className='sidebar'>
            {/* START sidebar nav */}
            <ul className='sidebar-nav'>
              {/* START user info */}
              <li className='has-user-block'>
                <SidebarUserBlock />
              </li>
              {canOpenV2({
                viewer: { akongoStaff: this.props.zoo?.akongoStaff === true },
                zooOptions: this.props.zooOptions,
              }) && (
                <li className='sidebar-interface-version-switch'>
                  <Suspense fallback={null}>
                    <LegacyInterfaceVersionSwitch />
                  </Suspense>
                </li>
              )}
              {/* END user info */}

              {/* Iterates over all sidebar items with section collapse support */}
              {this.renderMenuItems()}
            </ul>
            {/* END sidebar nav */}
          </nav>
        </div>
        {/* END Sidebar (left) */}
      </aside>
    )
  }
}

Sidebar.propTypes = {
  actions: PropTypes.object,
  settings: PropTypes.object,
}

const mapStateToProps = (state) => {
  console.log('Sidebar mapStateToProps - Current Redux state:', {
    zooTier: state.zoo.zooTier,
    userRole: state.zoo.userRole,
    zooId: state.zoo.zooId,
    timezone: state.zoo.timezone
  })
  return {
    settings: state.settings,
    zoo: state.zoo,
    zooTier: state.zoo.zooTier,
    userRole: state.zoo.userRole,
    timezone: state.zoo.timezone,
    zooOptions: state.zoo.zooOptions,
  }
}
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  setZooTier: (tier) => dispatch(setZooTier(tier)),
  setUserRole: (role) => dispatch(setUserRole(role)),
  setZooTimezone: (timezone) => dispatch(setZooTimezone(timezone)),
  setZooOptions: (options) => dispatch(setZooOptions(options)),
  setZooName: (name) => dispatch(changeZooName("zooName", name)),
  setAkongoStaff: (value) => dispatch(setAkongoStaff(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translations")(withRouter(Sidebar)))
